module.exports = __webpack_public_path__ + "fonts/Barlow-ExtraBold.6d3f2223.ttf";